const FieldLabel = ({ label, for: forProp }) => (
  <label htmlFor={forProp} className="block mb-1 text-sm text-gray-700">
    {label}
  </label>
);

export default FieldLabel;
